import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1052.000000 1027.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1027.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M1785 6375 c-293 -39 -591 -149 -843 -312 -186 -120 -261 -243 -262
-429 0 -176 94 -328 255 -409 158 -79 328 -65 487 42 184 124 360 181 588 190
213 8 355 -22 540 -115 88 -44 96 -50 109 -88 13 -36 13 -47 0 -79 -33 -88
-112 -101 -242 -40 -204 95 -422 107 -642 34 -102 -34 -180 -78 -277 -156
-105 -85 -132 -165 -85 -253 16 -30 37 -51 67 -67 77 -41 141 -27 233 50 65
54 87 67 162 98 52 21 76 24 180 24 110 0 125 -2 185 -29 196 -85 176 -80 300
-80 103 0 122 2 180 27 123 51 225 158 267 279 21 61 28 183 14 250 -30 142
-120 250 -277 330 -292 149 -598 196 -928 142 -164 -28 -381 -110 -505 -192
-35 -24 -77 -50 -92 -57 -67 -35 -149 -4 -170 63 -27 90 23 143 245 257 348
181 736 236 1116 159 225 -46 417 -127 610 -257 90 -61 112 -71 158 -75 107
-9 182 59 182 165 0 69 -22 107 -94 159 -262 193 -617 330 -966 373 -113 14
-371 12 -495 -4z"
          />
          <path
            d="M6430 6103 c-52 -19 -140 -51 -195 -71 l-100 -37 0 -40 c0 -36 3 -40
33 -49 48 -13 92 -68 92 -114 l0 -37 -93 -1 c-107 -1 -169 -21 -246 -79 -112
-86 -173 -212 -174 -360 -2 -246 150 -396 360 -356 45 8 151 12 316 11 l247
-2 0 45 c0 41 -2 45 -28 50 -43 9 -80 44 -92 87 -7 24 -10 213 -10 512 1 260
-3 473 -7 474 -4 1 -51 -14 -103 -33z m-196 -434 l26 -20 0 -267 c-1 -209 -4
-271 -14 -285 -33 -43 -143 -40 -178 3 -68 83 -64 418 5 522 24 35 78 68 113
68 12 0 33 -9 48 -21z"
          />
          <path
            d="M3925 6055 c-66 -35 -120 -68 -120 -72 0 -4 9 -33 19 -64 l19 -55
-91 -225 c-49 -123 -115 -287 -147 -364 -31 -77 -66 -154 -78 -172 -23 -33
-65 -63 -91 -63 -12 0 -16 -10 -16 -40 l0 -40 135 0 135 0 0 38 c0 33 -4 39
-31 49 -30 12 -31 14 -27 56 3 24 23 90 44 146 l39 101 170 0 170 0 39 -93
c57 -136 60 -217 6 -217 -13 0 -17 -10 -18 -40 l-2 -40 260 0 260 0 0 39 c0
36 -2 39 -35 45 -47 9 -92 66 -133 168 -19 46 -38 91 -43 101 -5 9 -30 68 -55
130 -88 215 -217 532 -244 602 -15 38 -31 70 -36 71 -5 2 -63 -26 -129 -61z
m-17 -340 c6 -16 33 -86 61 -154 28 -68 49 -126 47 -128 -5 -5 -266 -9 -266
-4 0 5 71 181 80 201 9 17 35 84 44 114 8 23 19 13 34 -29z m-82 11 c0 -14 -6
-22 -13 -19 -9 4 -9 9 0 24 15 24 15 24 13 -5z m374 -12 c0 -8 -19 -13 -24 -6
-3 5 1 9 9 9 8 0 15 -2 15 -3z m-407 -49 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2
15 9 16 15 13 8 -4z m-10 -90 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15
13 8 -4z m464 -27 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-526
-65 c-12 -20 -14 -14 -5 12 4 9 9 14 11 11 3 -2 0 -13 -6 -23z m286 -81 c7 -4
-18 -6 -55 -4 -96 5 -108 10 -27 11 39 0 76 -3 82 -7z m-297 -32 c0 -5 -5 -10
-11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-120 -207 c-11 -17
-11 -17 -6 0 3 10 6 24 7 30 0 9 2 9 5 0 3 -7 0 -20 -6 -30z m565 -132 c-3 -6
-11 -11 -16 -11 -5 0 -4 6 3 14 14 16 24 13 13 -3z"
          />
          <path
            d="M4980 6054 c-161 -35 -313 -150 -379 -288 -48 -100 -68 -233 -51
-344 18 -120 71 -226 158 -311 84 -84 158 -126 267 -151 109 -25 181 -25 281
0 130 34 219 88 286 175 21 28 42 55 46 60 13 16 48 106 63 160 21 74 18 257
-5 324 -68 199 -242 342 -456 376 -110 17 -122 17 -210 -1z m208 -83 c48 -25
75 -54 105 -116 76 -153 75 -512 -3 -693 -27 -62 -84 -116 -138 -133 -33 -9
-48 -9 -91 6 -132 44 -200 237 -188 539 6 144 19 212 55 282 21 40 81 102 117
122 31 18 102 14 143 -7z m-331 -7 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1
17 -2 13 -5z m-97 -49 c-7 -9 -15 -13 -19 -10 -3 3 1 10 9 15 21 14 24 12 10
-5z m143 -60 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z m-300
-155 c-3 -12 -8 -19 -11 -16 -5 6 5 36 12 36 2 0 2 -9 -1 -20z m1004 -32 c-3
-8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-790 -270 c-3 -8 -6 -5 -6
6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m820 -20 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m-20 -10 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12
1 -19z m-987 -95 c-1 -10 -39 39 -40 51 0 5 9 -3 20 -17 11 -14 20 -29 20 -34z
m921 -86 c-10 -9 -11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11 -7 -18z m-836 -47
c3 -6 -1 -7 -9 -4 -18 7 -21 14 -7 14 6 0 13 -4 16 -10z m322 -166 c-3 -3 -12
-4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m190 0 c-3 -3 -12 -4 -19 -1 -8 3
-5 6 6 6 11 1 17 -2 13 -5z"
          />
          <path
            d="M7722 5843 c-142 -180 -172 -224 -172 -250 l0 -33 79 0 79 0 4 -238
c3 -234 3 -239 28 -274 85 -126 257 -128 426 -6 36 26 42 34 32 44 -10 10 -24
11 -53 4 -54 -13 -98 -3 -127 27 -22 24 -23 30 -26 234 l-3 209 100 0 101 0 0
45 0 45 -100 0 -100 0 0 205 0 205 -49 0 -48 0 -171 -217z"
          />
          <path
            d="M6965 5754 c-172 -42 -273 -190 -205 -302 22 -36 54 -52 107 -52 84
0 129 65 118 172 -8 78 2 104 51 124 30 13 38 13 63 -1 40 -20 71 -89 78 -174
6 -70 6 -71 -19 -71 -76 0 -269 -88 -336 -153 -64 -62 -85 -108 -80 -177 7
-102 71 -154 200 -167 47 -4 85 0 150 16 71 18 94 20 125 12 21 -6 109 -11
196 -11 l157 0 0 45 c0 38 -3 45 -19 45 -11 0 -32 11 -48 24 l-28 24 -11 203
c-15 255 -25 292 -102 369 -73 72 -123 90 -246 89 -50 0 -118 -7 -151 -15z
m215 -514 c0 -136 -1 -142 -25 -165 -29 -30 -65 -32 -88 -7 -27 29 -40 124
-27 186 13 66 71 125 123 126 15 0 17 -13 17 -140z"
          />
          <path
            d="M8513 5755 c-107 -30 -180 -83 -213 -157 -25 -55 -25 -82 0 -134 25
-51 62 -69 128 -61 37 4 52 12 73 37 31 37 42 86 28 132 -27 96 68 172 136
108 30 -28 53 -97 57 -168 l3 -54 -75 -19 c-177 -45 -332 -154 -360 -253 -11
-40 -11 -58 -1 -95 32 -120 164 -167 345 -121 74 18 96 20 126 11 21 -6 110
-11 199 -11 l161 0 0 45 c0 39 -3 45 -21 45 -31 0 -57 17 -74 50 -11 22 -15
64 -15 168 0 271 -43 387 -171 457 -49 27 -64 30 -164 32 -73 2 -127 -2 -162
-12z m217 -500 c0 -144 -13 -190 -55 -201 -41 -10 -72 10 -84 53 -16 57 -13
143 7 185 20 43 75 88 109 88 23 0 23 -1 23 -125z"
          />
          <path
            d="M5491 4813 c-38 -19 -71 -66 -71 -101 0 -25 24 -77 47 -104 13 -15
11 -19 -25 -42 -81 -51 -107 -114 -77 -192 41 -108 189 -139 282 -59 l39 33
38 -40 38 -40 25 25 25 24 -42 39 -41 39 26 58 c15 32 25 60 24 61 -2 2 -18 7
-34 10 -28 6 -33 3 -48 -29 -9 -20 -21 -34 -26 -31 -4 3 -28 31 -52 62 -32 41
-40 59 -30 62 33 11 91 75 97 107 18 95 -98 165 -195 118z m109 -63 c35 -35
23 -78 -31 -113 -24 -16 -27 -16 -41 0 -21 25 -38 59 -38 77 0 24 37 56 65 56
14 0 34 -9 45 -20z m-17 -285 c53 -66 55 -70 39 -88 -56 -63 -148 -61 -185 3
-21 35 -21 64 -1 99 18 30 62 62 80 58 6 -1 37 -33 67 -72z"
          />
          <path
            d="M3480 4622 c0 -208 6 -249 44 -290 39 -44 75 -56 166 -56 87 0 114 8
158 48 47 42 54 78 60 294 l5 202 -37 0 -36 0 0 -172 c-1 -196 -8 -240 -45
-277 -23 -24 -33 -26 -105 -26 -73 0 -82 2 -106 27 -36 35 -44 95 -43 288 l1
155 -31 3 -31 3 0 -199z"
          />
          <path
            d="M4220 4785 c0 -33 2 -35 35 -35 33 0 35 2 35 35 0 33 -2 35 -35 35
-33 0 -35 -2 -35 -35z"
          />
          <path d="M4370 4550 l0 -270 35 0 35 0 0 270 0 270 -35 0 -35 0 0 -270z" />
          <path
            d="M4530 4785 c0 -33 2 -35 35 -35 33 0 35 2 35 35 0 33 -2 35 -35 35
-33 0 -35 -2 -35 -35z"
          />
          <path
            d="M6010 4551 l0 -271 142 0 c172 0 214 14 247 84 42 85 20 150 -67 202
-1 1 10 15 26 32 16 17 32 45 35 62 9 42 -18 105 -57 133 -28 20 -45 22 -178
25 l-148 4 0 -271z m268 203 c25 -7 52 -51 52 -83 0 -11 -11 -33 -24 -48 -23
-27 -29 -28 -125 -31 l-101 -4 0 86 0 86 88 0 c48 0 97 -3 110 -6z m22 -239
c59 -30 68 -98 21 -146 -29 -28 -32 -29 -135 -29 l-106 0 0 95 0 95 95 0 c66
0 105 -5 125 -15z"
          />
          <path
            d="M6510 4785 c0 -33 2 -35 35 -35 33 0 35 2 35 35 0 33 -2 35 -35 35
-33 0 -35 -2 -35 -35z"
          />
          <path
            d="M6666 4812 c-2 -4 -5 -126 -5 -270 l0 -262 35 0 34 0 0 270 0 270
-29 0 c-17 0 -32 -4 -35 -8z"
          />
          <path d="M6820 4550 l0 -270 35 0 35 0 0 270 0 270 -35 0 -35 0 0 -270z" />
          <path
            d="M7100 4551 l0 -271 35 0 35 0 0 109 0 109 120 4 c129 4 150 12 193
70 46 61 27 175 -36 222 -25 19 -45 21 -188 24 l-159 4 0 -271z m311 180 c21
-22 29 -39 29 -66 0 -80 -43 -105 -180 -105 l-90 0 0 100 0 100 106 0 c103 0
106 -1 135 -29z"
          />
          <path
            d="M8020 4785 c0 -33 2 -35 35 -35 33 0 35 2 35 35 0 33 -2 35 -35 35
-33 0 -35 -2 -35 -35z"
          />
          <path
            d="M4043 4790 c-29 -18 -33 -25 -33 -65 0 -38 -3 -45 -20 -45 -16 0 -20
-7 -20 -36 0 -31 3 -36 20 -31 19 5 20 0 20 -121 0 -150 11 -199 46 -212 33
-13 91 -13 99 0 12 20 -6 50 -29 50 -42 0 -47 19 -44 156 l3 129 33 -3 c31 -3
32 -2 32 32 0 34 -2 36 -35 36 l-34 0 -3 65 -3 65 -32 -20z"
          />
          <path
            d="M4718 4792 c-24 -15 -28 -23 -28 -64 0 -45 -2 -48 -26 -48 -23 0 -25
-3 -22 -32 2 -25 8 -33 23 -33 19 0 20 -8 25 -153 5 -147 6 -155 29 -173 15
-12 39 -19 67 -19 42 0 44 1 44 30 0 27 -3 30 -30 30 -38 0 -42 13 -38 165 l3
120 30 0 c27 0 30 3 30 30 0 27 -3 30 -32 30 l-33 0 0 67 c0 38 -3 68 -7 67
-5 0 -20 -8 -35 -17z"
          />
          <path
            d="M8622 4788 c-30 -19 -33 -25 -30 -62 2 -36 0 -41 -20 -44 -18 -3 -22
-10 -22 -38 0 -27 4 -34 20 -34 19 0 20 -7 20 -122 0 -145 10 -190 46 -206 29
-14 90 -16 98 -4 12 19 -7 52 -29 52 -40 0 -46 19 -43 156 l3 129 33 -3 c31
-3 32 -2 32 32 0 34 -2 36 -35 36 l-34 0 -3 65 -3 64 -33 -21z"
          />
          <path
            d="M4227 4674 c-4 -4 -7 -94 -7 -201 l0 -193 35 0 35 0 -2 198 -3 197
-25 3 c-14 2 -29 0 -33 -4z"
          />
          <path d="M4530 4481 l0 -201 35 0 35 0 -2 198 -3 197 -32 3 -33 3 0 -200z" />
          <path
            d="M4860 4666 c0 -8 30 -101 66 -207 l67 -192 -22 -43 c-19 -40 -24 -44
-57 -44 -29 0 -35 -3 -30 -16 3 -9 6 -22 6 -30 0 -10 12 -14 41 -14 57 0 87
35 128 151 79 225 141 403 141 407 0 2 -17 2 -37 0 l-36 -3 -50 -148 c-27 -82
-51 -146 -54 -143 -3 3 -27 69 -52 148 -47 142 -47 143 -79 146 -23 2 -32 -1
-32 -12z"
          />
          <path
            d="M6517 4673 c-4 -3 -7 -93 -7 -200 l0 -193 35 0 35 0 0 200 0 200 -28
0 c-16 0 -32 -3 -35 -7z"
          />
          <path
            d="M7671 4659 c-19 -11 -42 -30 -52 -42 -41 -50 -49 -189 -14 -257 51
-98 193 -120 277 -41 34 31 41 45 50 102 27 156 -42 259 -172 259 -38 0 -65
-6 -89 -21z m147 -55 c50 -35 68 -136 38 -209 -15 -35 -59 -65 -96 -65 -37 0
-81 30 -96 65 -29 71 -11 175 37 209 30 20 88 21 117 0z"
          />
          <path d="M8020 4481 l0 -201 35 0 35 0 -2 198 -3 197 -32 3 -33 3 0 -200z" />
          <path
            d="M8177 4673 c-4 -3 -7 -93 -7 -200 l0 -193 34 0 34 0 4 146 c3 146 3
146 31 170 37 31 96 33 123 3 17 -18 19 -40 22 -170 l3 -149 36 0 35 0 -4 163
c-3 133 -6 167 -21 188 -37 55 -128 66 -191 24 l-36 -24 0 24 c0 21 -5 25 -28
25 -16 0 -32 -3 -35 -7z"
          />
          <path
            d="M1955 4601 c-49 -22 -107 -84 -123 -130 -17 -48 -15 -142 3 -186 47
-111 185 -168 306 -127 85 29 149 125 149 223 0 100 -56 186 -145 224 -51 21
-141 19 -190 -4z"
          />
          <path
            d="M8820 4316 c0 -35 1 -36 36 -36 34 0 35 1 32 33 -3 28 -7 32 -35 35
-32 3 -33 2 -33 -32z"
          />
          <path
            d="M9036 4343 c-3 -4 -6 -19 -6 -35 0 -25 3 -28 35 -28 33 0 35 2 35 33
0 31 -3 34 -29 35 -16 0 -32 -2 -35 -5z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>; // Render logo without any link
  }

  // Render as external link
  return (
    <a
      href="https://www.aodata.ng"
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
